import { render } from "./CargaIdentificacion.vue?vue&type=template&id=689d22ed"
import script from "./CargaIdentificacion.vue?vue&type=script&lang=js"
export * from "./CargaIdentificacion.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/APLM/APLM/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__